
<ng-template ngIf [ngIf]="loaded">
    <app-navigation [class.collapsed]="isMenuCollapsed"  [collapsed]="isMenuCollapsed" (openElement)="onMenuToggle()" (menuToggle)="onMenuToggle()">
    </app-navigation>
    <div class="main-wrapper" [class.menu-collapsed]="isMenuCollapsed">
        <app-header></app-header>
        <ui-view class="main-view"></ui-view>
    </div>
</ng-template>

